import { Grid, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import InsurancePageLayout from "../../Insurance/Base/pages/InsurancePageLayout";
import EuroIcon from "@mui/icons-material/Euro";
import PaymentsIcon from "@mui/icons-material/Payments";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import BusinessIcon from "@mui/icons-material/Business";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import SettingsIcon from "@mui/icons-material/Settings";
import { recnungTransactionMethods, transactionMethods } from "../../Kasse/v2/types/kasse.types";
import FiskalyController from "../components/FiskalyController";
import TransactionsOverviewContainer from "../../Kasse/v2/pages/TransactionsOverviewContainer";
import SepaExportManager from "../../Kasse/v2/Sepa/SepaExportManager";

export default function TransactionPage() {
  const [selectedTabs, setSelectedTabs] = useState(1);

  const handleTabChange = (event: any, newValue: any) => {
    setSelectedTabs(newValue);
  };

  return (
    <div style={{ margin: "5px" }}>
      <Grid item xs={12} md sx={{ border: "0px solid" }}>
        <Tabs
          orientation="horizontal"
          value={selectedTabs}
          onChange={handleTabChange}
          aria-label="sub-tabs"
        >
          <Tab
            iconPosition="start"
            label={
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                ABRECHNUNG
              </span>
            }
            value={1}
            icon={
              <BusinessIcon
                sx={{
                  fontWeight: selectedTabs === 1 ? "bold" : "normal",
                }}
              />
            }
          />
          <Tab
            iconPosition="start"
            label={
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                OFFENE POSTEN
              </span>
            }
            value={2}
            icon={
              <ReceiptIcon
                sx={{
                  fontWeight: selectedTabs === 2 ? "bold" : "normal",
                }}
              />
            }
          />
          <Tab
            iconPosition="start"
            label={
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                CASH
              </span>
            }
            icon={
              <PaymentsIcon
                sx={{
                  fontWeight: selectedTabs === 3 ? "bold" : "normal",
                }}
              />
            }
            value={3}
          />
          <Tab
            iconPosition="start"
            label={
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                EC CASH
              </span>
            }
            value={4}
            icon={
              <EuroIcon
                sx={{
                  fontWeight: selectedTabs === 4 ? "bold" : "normal",
                }}
              />
            }
          />
          {/* <Tab
            iconPosition="start"
            label={
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                LASTSCHRIFT
              </span>
            }
            value={5}
            icon={
              <AccountBalanceWalletIcon
                sx={{
                  fontWeight: selectedTabs === 5 ? "bold" : "normal",
                }}
              />
            }
          /> */}
          <Tab
            iconPosition="start"
            label={
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                BANK TRANSFER
              </span>
            }
            value={5}
            icon={
              <AssuredWorkloadIcon
                sx={{
                  fontWeight: selectedTabs === 6 ? "bold" : "normal",
                }}
              />
            }
          />
          <Tab
            iconPosition="start"
            label={
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                SEPA LASTSCHRIFT
              </span>
            }
            value={6}
            icon={
              <CreditScoreIcon
                sx={{
                  fontWeight: selectedTabs === 8 ? "bold" : "normal",
                }}
              />
            }
          />
          <Tab
            iconPosition="start"
            label={
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                STEUERKONTROLLEUR
              </span>
            }
            value={7}
            icon={
              <SettingsIcon
                sx={{
                  fontWeight: selectedTabs === 7 ? "bold" : "normal",
                }}
              />
            }
          />
        </Tabs>
      </Grid>
      {(() => {
        switch (selectedTabs) {
          case 1:
            return <InsurancePageLayout />;
          case 2:
            return (
              <TransactionsOverviewContainer
                transactionMethod={recnungTransactionMethods.RECHNUNG}
              />
            );
          case 3:
            return <TransactionsOverviewContainer transactionMethod={transactionMethods.CASH} />;
          case 4:
            return <TransactionsOverviewContainer transactionMethod={transactionMethods.EC} />;
          // case 5:
          //   return (
          //     <TransactionsDisplayContainer transactionMethod={transactionMethods.LASTSCHRIFT} />
          //   );
          case 5:
            return (
              <TransactionsOverviewContainer
                transactionMethod={recnungTransactionMethods.BANK_TRANSFER}
              />
            );
          case 6:
            return <SepaExportManager />;
          case 7:
            return <FiskalyController />;

          default:
            return null;
        }
      })()}
    </div>
  );
}
